module.exports = __webpack_public_path__ + "img/emailbanner.old.1bb4c394.png";